import { connect } from 'react-redux'

import ImportsList from 'components/Imports/ImportLogs'
import { receiveImports } from 'modules/imports/actions'

const mapStateToProps = state => {
  return {
    orgId: state.user.orgId,
    imports: state.__CRM.imports.imports
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReceiveImports: imports => {
      dispatch(receiveImports(imports))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportsList)
